import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import TypeableDatePortal from '@/components/edit/TypeableDatePortal/index.vue'
import fetch from '@/helpers/fetch'
import { Auditoria } from '@/types/auditoria'

@Component({ components: { TypeableDatePortal } })
export default class ModalAuditoriaEdit extends Vue {
	@Prop({ default: null }) auditoria!: Auditoria | null

	form: any = {}
	saving = false

	options = {
		source: [
			{ value: 'carta', text: 'Carta' },
			{ value: 'relatório', text: 'Relatório' },
		],
		response_type: [
			{ value: 'email', text: 'E-mail' },
			{ value: 'portal-terceiro', text: 'Portal terceiro' },
			{ value: 'correio', text: 'Correio' },
		],
	}

	@Watch('auditoria', { immediate: true })
	onAuditoriaChange(val: Auditoria | null) {
		if (!val) return
		this.form = {
			id: val.id,
			source: val.source,
			response_type: val.response_type,
			request_date: val.request_date,
			base_date: val.base_date,
			response_deadline: val.response_deadline,
			obs: val.obs,
		}
	}

	onShow() {
		this.saving = false
	}

	get title(): string {
		return this.auditoria ? `Auditoria — ${this.auditoria.group?.name || ''}` : 'Auditoria'
	}

	async save() {
		this.saving = true
		try {
			const payload = {
				source: this.form.source,
				response_type: this.form.response_type,
				request_date: this.form.request_date || null,
				base_date: this.form.base_date || null,
				response_deadline: this.form.response_deadline || null,
				obs: this.form.obs || null,
			}
			const res = await fetch.put(`/api/audits/${this.form.id}/update`, payload)
			if (res.ok) {
				this.$bvToast.toast('Auditoria salva com sucesso.', {
					title: 'Salvo',
					variant: 'success',
					noCloseButton: true,
					autoHideDelay: 3000,
					toaster: 'b-toaster-top-center',
				})
				this.$emit('saved', { ...this.auditoria, ...payload })
				this.$bvModal.hide('modal-auditoria-edit')
			} else {
				this.$bvToast.toast(res.msg || 'Erro ao salvar.', {
					title: 'Erro',
					variant: 'danger',
					noCloseButton: false,
					noAutoHide: true,
					toaster: 'b-toaster-top-center',
				})
			}
		} finally {
			this.saving = false
		}
	}

	cancel() {
		this.$bvModal.hide('modal-auditoria-edit')
	}
}
